/**
 * Extract locale parameter from current location
 *
 * @param pathname
 * @return string
 */
export const extractLocale = (pathname = "") => {
    const matches = new RegExp("/([^/]+)", "gi").exec(pathname);
    return matches && matches.length > 0 ? matches[1] : "";
};
/**
 * getMarketFromLanguage
 *
 * @param languageCode
 * @param markets
 * @return Market | null
 */
export const getMarketFromLanguage = (markets, languageCode = "") => markets.find((market) => market.languageCode === languageCode) || null;
/**
 * getMarketFromLocale
 *
 *
 * @param markets
 * @param locale
 * @return Market | null
 */
export const getMarketFromLocale = (markets, locale = "") => markets.find((market) => market.locale === locale) || null;
/**
 * Get the current market from a given pathname, by extracting the locale parameter
 *
 *
 * @return Market | null
 * @param markets
 * @param pathname
 */
export const getMarketFromLocation = (markets, pathname = "") => getMarketFromLocale(markets, extractLocale(pathname));
/**
 * Guess a market from a list of languages
 * Such as provided by the Navigator API (window.navigator.languages)
 *
 * @param markets
 * @param languages
 * @return Market | null
 */
export const guessMarketFromLanguages = (markets, languages = []) => {
    let defaultMarket = null;
    languages
        // case-insensitive comparison
        .map((language) => language.toLowerCase())
        // Loop through all the languages (order matters!)
        .find((language) => {
        // First try to match a direct locale parameter
        defaultMarket = markets.find((market) => market.locale.toLowerCase() === language);
        // locale not matched, trying to find a market by {languageCode}-{countryCode}
        if (!defaultMarket) {
            defaultMarket = markets.find((market) => `${market.languageCode.toLowerCase()}-${market.countryCode.toLowerCase()}` ===
                language);
            // combination not matched neither, trying to find a market by {languageCode}
            if (!defaultMarket) {
                defaultMarket = markets.find((market) => market.languageCode.toLowerCase() === language);
            }
        }
        // Break the loop if a market is found
        return defaultMarket !== null;
    });
    return defaultMarket || null;
};
